// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"j_1","subcategoryColumn":"j_2","articleLink":"j_3","articleCoverImage":"j_4","articleTitle":"j_5"};